import { QueryClient } from '@tanstack/react-query'

import { aoPerderASessao, ApiError } from '@/lib/api'
import { esquecerSessao } from '@/lib/sessao'

const ONE_MINUTE = 60_000
const MAX_RETRIES = 2

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: ONE_MINUTE,
      // Retentar um 401 ou um 404 só atrasa o feedback ao usuário.
      retry: (attempt, error) => {
        if (error instanceof ApiError && error.status < 500) return false
        return attempt < MAX_RETRIES
      },
    },
  },
})

/**
 * Verdadeiro quando a página aberta é uma tela da Área do Gestor. Só nela a
 * sessão que cai apaga o cache: no observatório público, a prévia de camada ou
 * de tooltip pede rota da gestão e trata o próprio 401 (mostra "entre na Área
 * do Gestor"); apagar ali tiraria essa mensagem e os dados do mapa da tela.
 */
export function naAreaDoGestor(caminho: string = window.location.pathname): boolean {
  return caminho === '/gestor' || caminho.startsWith('/gestor/')
}

// Um 401 numa rota que exigia sessão, com uma tela da Área do Gestor aberta,
// quer dizer que a sessão caiu com a página aberta: o que foi lido com ela sai
// da tela, e a guarda volta à entrada.
aoPerderASessao(() => {
  if (naAreaDoGestor()) esquecerSessao(queryClient)
})
